import React from "react";
import { Link } from "react-router-dom";
import { CanadaFlagIcon } from "../../assets/svgs";

interface AuthFooterProps {
  extraClasses?: string;
}

const AuthFooter: React.FC<AuthFooterProps> = ({ extraClasses = "" }) => {
  return (
    <div
      className={`sticky bottom-0 left-0 right-0 z-10 flex items-center flex-col md:flex-row gap-2 md:gap-0 justify-between px-6 py-4 text-white text-sm bg-[#111C3D] border-white/20 ${extraClasses}`}
    >
      <div className="flex items-center space-x-2.5">
        <span>© 2026 Docnote. All rights reserved.</span>
        <CanadaFlagIcon />
      </div>
      <div className="flex items-center space-x-4">
        <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" className="hover:text-gray-200">
          Terms of Use
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-200">
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default AuthFooter;
